import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export type AccordionItem = {
  title: string;
  content: string;
  image?: string;
  imageAlt?: string;
};
type AccordionProps = {
  items: AccordionItem[];
  variant?: 'teal' | 'amber';
};
export function Accordion({
  items,
  variant = 'teal'
}: AccordionProps) {
  const [open, setOpen] = useState<number | null>(0);
  const accent = variant === 'teal' ? 'border-teal-400/25 bg-teal-500/10' : 'border-amber-400/25 bg-amber-500/10';
  return <div className="space-y-3" data-id="element-18" data-mp="2w4ne05k0gxzz">
      {items.map((item, i) => {
      const isOpen = open === i;
      return <div key={item.title} className={`overflow-hidden rounded-2xl border ${accent}`} data-id="element-19" data-mp="2s2ionj0linj5" data-mpi={i}>
            {item.image ? <div className="relative h-28 w-full overflow-hidden bg-white" data-id="element-20" data-mp="11sp5k5tj0655">
                <img src={item.image} alt={item.imageAlt ?? item.title} className="h-full w-full object-cover object-top" data-id="element-21" data-mp="xqlql77nejf4" />
                <div aria-hidden="true" className={`pointer-events-none absolute inset-0 bg-gradient-to-t ${variant === 'amber' ? 'from-[#0b2431] via-[#0b2431]/45' : 'from-[#0b2431] via-[#0b2431]/40'} to-transparent`} data-id="element-22" data-mp="3l3yp4yglvihj" />
              </div> : null}
            <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-23" data-mp="7mzcebteo1m7">
              <span className="text-sm font-bold text-white" data-id="element-24" data-mp="2eeqf7q39g32k">{item.title}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-teal-200 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-25" data-mp="2egutn1ysckh3" />
            </button>
            <AnimatePresence initial={false} data-id="element-26" data-mp="27clgfu76nhnj">
              {isOpen ? <motion.div key="content" initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.25,
            ease: 'easeInOut'
          }} data-id="element-27" data-mp="2lbuo25hbp3fw">
                  <p className="px-4 pb-4 text-sm leading-relaxed text-teal-50/80" data-id="element-28" data-mp="2qb7hxa6m3arz">
                    {item.content}
                  </p>
                </motion.div> : null}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}